import { render, staticRenderFns } from "./FlightBoxOneApp.vue?vue&type=template&id=b2162b96&scoped=true"
import script from "./FlightBoxOneApp.vue?vue&type=script&lang=js"
export * from "./FlightBoxOneApp.vue?vue&type=script&lang=js"
import style0 from "./FlightBoxOneApp.vue?vue&type=style&index=0&id=b2162b96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2162b96",
  null
  
)

export default component.exports